export default "__VITE_ASSET__DwscmmaQ__"